<template>
  <b-container fluid>
    <!-- User Interface controls -->
    <b-row class="mt-3">
      <b-col
        lg="6"
        class="my-1"
      >
        <b-form-group
          label-for="filter-input"
          class="mb-0"
        >
          <b-input-group>
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Søk lokasjoner"
            ></b-form-input>

            <b-input-group-append>
              <b-button
                variant="primary"
                :disabled="!filter"
                @click="filter = ''"
              >Tøm</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <br />

    <!-- Main table element -->
    <b-table
      :items="site"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      :primary-key="id"
      show-empty
      small
      @filtered="onFiltered"
    >
      <template #row-details="row">
        <b-card>
          <ul>
            <li
              v-for="(value, key) in row.item"
              :key="key"
            >
              {{ key }}: {{ value }}
            </li>
          </ul>
        </b-card>
      </template>
    </b-table>

    <br />

    <b-row class="m-3">
      <b-col
        sm="7"
        md="3"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="site.length"
          :per-page="perPage"
          align="fill"
        ></b-pagination>
      </b-col>

      <b-col
        sm="2"
        md="3"
      >
        <b-form-group
          label="Antall pr. side"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="3"
          label-cols-lg="3"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Info modal -->
    <b-modal
      :id="infoModal.id"
      :title="infoModal.title"
      ok-only
      @hide="resetInfoModal"
    >
      <pre>{{ infoModal.content }}</pre>
    </b-modal>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      site: [],
      fields: [
        {
          key: "number",
          label: "Nummer",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "name",
          label: "Navn",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "owner",
          label: "Eier",
          sortable: true,
        },
        {
          key: "lat",
          label: "LAT",
          sortable: true,
        },
        {
          key: "lng",
          label: "LNG",
          sortable: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [50, 100, 500, 1000],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.site.length;
  },
  methods: {
    getAquaregister() {
      this.isLoading = true;
      axios
        .get("https://api.eines-as.no/sites?_limit=-1")
        .then((res) => {
          this.site = res.data;
          this.isLoading = false;
        });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created: function () {
    this.getAquaregister();
  },
};
</script>
